<script>
  import { onMount } from "svelte";
  import DeleteIcon from "./DeleteIcon.svelte";

  let items = [];
  let pickInProgress = false;
  let name = "";
  let selectedIndex = null;

  onMount(() => {
    const savedItems = localStorage.getItem("p4m-items");
    if (savedItems) {
      items = JSON.parse(savedItems);
    }
  });

  function saveListToLocalStorage() {
    localStorage.setItem("p4m-items", JSON.stringify(items));
  }

  function handleAddEntry() {
    if (name.length === 0) return;
    const newItems = name.split(",").map((n, i) => {
      return {
        name: n,
        id: items.length + i,
      };
    });
    items = [...items, ...newItems];
    selectedIndex = null;
    name = "";
    saveListToLocalStorage();
  }

  function handleDeleteEntry(indexToDelete) {
    if (pickInProgress) return;
    items = items.filter((item, index) => index !== indexToDelete);
    saveListToLocalStorage();
  }

  function handleClearList() {
    items = [];
    saveListToLocalStorage();
  }

  function handlePick() {
    pickInProgress = true;
    let timesRun = 0;
    const interval = setInterval(() => {
      let nextSelectedIndex = selectedIndex;
      while (nextSelectedIndex === selectedIndex) {
        nextSelectedIndex = Math.floor(Math.random() * items.length);
      }
      selectedIndex = nextSelectedIndex;
      timesRun++;
      if (timesRun === 18) {
        clearInterval(interval);
        pickInProgress = false;
      }
    }, 150);
  }
</script>

<main>
  <h1>Pick For Me</h1>
  <form on:submit|preventDefault={handleAddEntry}>
    <input bind:value={name} placeholder="Add a new item" />
    <button disabled={pickInProgress} type="submit">Add</button>
    <small>add multiple items at once: "pizza, sushi, tacos" </small>
  </form>
  <div class="btn-group">
    <button
      disabled={pickInProgress || items.length === 0}
      on:click={handleClearList}
      >Clear List
    </button>
    <button
      disabled={pickInProgress || items.length < 2}
      on:click={handlePick}
      class="pick-btn"
      >Pick For Me
    </button>
  </div>
  {#if items.length > 0}
    <div class="items">
      <ul>
        {#each items as { id, name }, index}
          <li class={index === selectedIndex ? "selected" : ""}>
            {name}
            <DeleteIcon {handleDeleteEntry} {index} />
          </li>
        {/each}
      </ul>
    </div>
  {:else}
    <p>Add some items and click 'Pick For Me' to have one randomly selected!</p>
  {/if}
</main>

<style>
  main {
    margin-left: auto;
    margin-right: auto;
    padding: 1em 2em;
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 0.5fr auto;
    max-width: 30em;
  }

  h1 {
    color: #ff3e00;
    text-align: center;
    font-weight: 150;
  }

  small {
    grid-column: span 2;
  }

  form {
    display: grid;
    grid-template-columns: auto 5rem;
    grid-template-rows: 1fr 1fr;
  }

  .items {
    display: grid;
  }

  ul {
    padding: 0;
  }

  li {
    display: flex;
    justify-content: space-between;
    padding: 0.75rem 0.75rem 0.5rem 0.75rem;
    border-bottom: 1px solid #ff3e00;
  }

  .btn-group {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 1em;
  }

  .selected {
    background-color: #ff3e00;
    color: white;
  }

  p {
    font-weight: 200;
  }

  /*form {*/
  /*  margin-left: auto;*/
  /*  margin-right: auto;*/
  /*  width: clamp(20em, 50%, 30em);*/
  /*  display: grid;*/
  /*  align-items: center;*/
  /*  grid-template-rows: 1fr 1fr;*/
  /*  grid-template-columns: auto min-content;*/
  /*}*/

  /*small {*/
  /*  grid-row: 2;*/
  /*}*/

  /*.pick-btn {*/
  /*  margin-bottom: 0;*/
  /*  margin-top: 1rem;*/
  /*}*/

  /*.selected {*/
  /*  background-color: #ff3e00;*/
  /*  color: white;*/
  /*}*/

  /*.items {*/
  /*  display: grid;*/
  /*  place-items: center;*/
  /*}*/

  /*ul {*/
  /*  width: clamp(20em, 50%, 30em);*/
  /*}*/

  /*li {*/
  /*  display: flex;*/
  /*  justify-content: space-between;*/
  /*  padding: 0.75rem 0.75rem 0.5rem 0.75rem;*/
  /*  border-bottom: 1px solid #ff3e00;*/
  /*}*/

  /*main {*/
  /*  text-align: center;*/
  /*  padding: 1em;*/
  /*  max-width: 240px;*/
  /*  margin: 0 auto;*/
  /*}*/

  /*h1 {*/
  /*  color: #ff3e00;*/
  /*  text-transform: uppercase;*/
  /*  font-size: 4em;*/
  /*  font-weight: 100;*/
  /*}*/

  /*@media (min-width: 640px) {*/
  /*  main {*/
  /*    max-width: none;*/
  /*  }*/
  /*}*/
</style>
